import FormsEmailField from "../../fields/forms-email-field.vue";
import FormsInputField from "../../fields/forms-input-field.vue";
import FormsCheckboxField from "../../fields/forms-checkbox-field.vue";
import FormsCountrySelectField from "../../fields/forms-country-select-field.vue";
import FormsDisclaimerField from "../../fields/forms-disclaimer-field.vue";
import FormsDisclaimers from "../../fields/forms-disclaimers.vue";
import FormsErrorMessage from "../../messages/forms-error-message.vue";
import FormsEventSessionsField from "../../fields/forms-event-sessions-field.vue";
import FormsHiddenField from "../../fields/forms-hidden-field.vue";
import FormsMessageField from "../../fields/forms-message-field.vue";
import FormsMultiCheckboxField from "../../fields/forms-multi-checkbox-field.vue";
import FormsPhoneField from "../../fields/forms-phone-field.vue";
import FormsSelectField from "../../fields/forms-select-field.vue";
import FormsStateSelectField from "../../fields/forms-state-select-field.vue";
import FormsSubmitButton from "../../fields/forms-submit-button.vue";
import FormsSuccessMessage from "../../messages/forms-success-message.vue";
import FormsResourceDocumentSuccessMessage from "../../messages/forms-resource-document-success-message.vue";
import FormsTextareaField from "../../fields/forms-textarea-field.vue";
import FormsUrlField from "../../fields/forms-url-field.vue";

export default {
    components: {
        FormsEmailField,
        FormsInputField,
        FormsCheckboxField,
        FormsCountrySelectField,
        FormsDisclaimerField,
        FormsDisclaimers,
        FormsErrorMessage,
        FormsEventSessionsField,
        FormsHiddenField,
        FormsMessageField,
        FormsMultiCheckboxField,
        FormsPhoneField,
        FormsSelectField,
        FormsStateSelectField,
        FormsSubmitButton,
        FormsSuccessMessage,
        FormsResourceDocumentSuccessMessage,
        FormsTextareaField,
        FormsUrlField
    }
};